module.exports = __webpack_public_path__ + "media/images/global/icons/photo-background-5571f8cf661bc8f004844d5274a3046d.svg";